var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1984,
    height: 482,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1698.48,
    y1: 691.987,
    x2: 1698.48,
    y2: 959.987,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00B0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1078E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2141DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1698.61,
    y1: 596.515,
    x2: 1698.61,
    y2: 684.121,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00B0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1078E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2141DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1358.53,
    y1: 979.379,
    x2: 1499.04,
    y2: 670.891,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1930AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#192DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192BAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1716.57,
    y1: 1000.08,
    x2: 1459.39,
    y2: 581.898,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1930AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1D38C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2141DF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1341 -599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1742.43 735.949C1742.36 711.579 1722.47 691.918 1698.07 691.987L1698.07 691.987C1673.63 692.056 1653.91 711.888 1653.98 736.224L1654.53 916.024C1654.6 940.393 1674.49 960.056 1698.89 959.987L1698.89 959.987C1723.33 959.918 1743.05 940.087 1742.98 915.749L1742.43 735.949Z",
    fill: "url(#fill0)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.34 631.27C1738.34 650.465 1726.85 670.077 1707.66 675.074 1688.48 680.071 1668.88 668.561 1663.88 649.365 1658.88 630.17 1670.38 610.559 1689.56 605.562 1708.74 600.565 1728.34 612.075 1733.34 631.27Z",
    fill: "url(#fill1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486.79 668.871C1510.1 677.525 1521.98 703.452 1513.33 726.781L1428.67 954.829C1420.01 978.157 1394.09 990.053 1370.78 981.399L1370.78 981.399C1347.46 972.745 1335.58 946.816 1344.24 923.489L1428.9 695.44C1437.56 672.112 1463.48 660.216 1486.79 668.871Z",
    fill: "url(#fill2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.24 899.177C1742.38 909.501 1742.76 917.727 1730.87 923.301 1718.48 929.119 1709.62 920.48 1706.42 913.907 1706.42 913.872 1706.39 913.838 1706.35 913.769L1577.99 648.604C1575.65 641.033 1572.01 633.909 1567.24 627.543 1564.63 623.619 1561.47 620.247 1557.93 617.425 1551.72 611.884 1544.4 607.376 1536.16 604.312L1536.16 604.312C1500.51 591.063 1460.92 609.268 1447.7 644.991L1431.25 689.42C1430.8 690.659 1430.39 691.898 1429.98 693.171 1431.56 689.489 1433.59 686.082 1435.99 683.054 1452.58 661.991 1485.78 666.362 1497.67 690.384L1514.22 723.869C1514.22 723.869 1528.91 754.188 1536.19 769.125L1625.31 953.174C1631.84 966.698 1644.23 975.406 1657.93 977.849 1673.63 983.805 1691.62 983.563 1707.9 975.613L1707.9 975.613C1736.61 961.606 1752.82 928.74 1743.2 899.143Z",
    fill: "url(#fill3)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#1F2B56",
    fontFamily: "Varela Round,Varela Round_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 223,
    transform: "matrix(1 0 0 1 1818.88 883)"
  }, "Web Scraper"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be43b48dde2491d58990ae7071de735a.svg";
export { ForwardRef as ReactComponent };